import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsUpdateAutomation, IResponseUpdateAutomation } from "./types"
import { useApi } from "../../useApi"
import { UpdateAutomationUrl } from "../../../utils/constants"

async function postUpdateAutomation(
	responseData: IPropsUpdateAutomation,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseUpdateAutomation> =
			await apiPrivate.post(`${UpdateAutomationUrl}?id=${responseData?.id}`, { ...responseData })

		return response
	} catch (error: any) {
		return error.response
	}
}

export function usePostUpdateAutomation(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseUpdateAutomation>,
					unknown,
					unknown,
					AxiosResponse<IResponseUpdateAutomation>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsUpdateAutomation) =>
			postUpdateAutomation(data, apiPrivate),
		...options,
	})
	return mutation
}
